import React from 'react';
import PropTypes from 'prop-types';
import { TableRow, Typography } from '@mui/material';
import TableCell from 'src/components/Table/TableCell';
import { formatPositiveAmount } from 'src/utils/formatAmout';
import { roundNumberToDecimals } from 'src/utils/common';
import selectFormatDate from 'src/utils/selectDateFormat';
import dateFormatType from 'src/utils/dateFormatType';

const InterestBalanceScheduleRow = ({
  period,
  rawDate,
  initialBalance,
  subscription,
  interest,
  finalBalance
}) => {
  return (
    <TableRow hover>
      <TableCell align="center">{period ?? '-'}</TableCell>
      <TableCell align="center">
        {rawDate ? selectFormatDate(rawDate, dateFormatType.MONTH_AND_YEAR) : '-'}
      </TableCell>  
      <TableCell align="center">
        {formatPositiveAmount(roundNumberToDecimals(initialBalance ?? 0))}
      </TableCell>
      <TableCell align="center">
        {formatPositiveAmount(roundNumberToDecimals(subscription ?? 0, 2))}
      </TableCell>
      <TableCell align="center">
        {formatPositiveAmount(roundNumberToDecimals(interest ?? 0, 2))}
      </TableCell>
      <TableCell align="center">
        <Typography component="span" sx={{ fontWeight: 'bold' }}>
          {formatPositiveAmount(roundNumberToDecimals(finalBalance ?? 0))}
        </Typography>
      </TableCell>
    </TableRow>
  );
};

InterestBalanceScheduleRow.propTypes = {
  period: PropTypes.number,
  rawDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  initialBalance: PropTypes.number,
  subscription: PropTypes.number,
  interest: PropTypes.number,
  finalBalance: PropTypes.number
};

export default InterestBalanceScheduleRow;

